import PageWrapper from '@/components/page-wrapper'
import AiSearchField from '@/components/ai-chat/ai-search-field'

type SearchProps = {
  headerNav: any
  footerNav: any
  headerBanners: any
  newsletterForm: any
}

export default function SmartSearch({ headerNav, footerNav, headerBanners, newsletterForm }: SearchProps) {
  return (
    <PageWrapper
      seo={{ fields: { title: 'Smart Search' } }}
      footerNav={footerNav}
      headerNav={headerNav}
      headerBanners={headerBanners}
      newsletterForm={newsletterForm}
    >
      <div className="max-w-5xl px-4 mx-auto pb-32 mt-8 lg:mt-10 min-h-[50vh]">
        <div className="flex flex-col items-center justify-center">
          <h1 className="relative mb-0 leading-none">Smart Search</h1>
        </div>
        <p className="text-center">
          Need help or have questions? Chat with our smart assistant for support and insights
        </p>
        <AiSearchField />
        <p className="text-center text-sm text-secondary-500 dark:text-secondary-200 mt-4">
          Bitwarden Smart Search is an experimental feature.
        </p>
      </div>
    </PageWrapper>
  )
}
